














import { Component, Vue } from 'vue-property-decorator';
import { mapGetters, mapState } from 'vuex';
import { MetaInfo } from 'vue-meta';
import { User } from 'frontend/types';

import DailyChallengeBase from './components/DailyChallengeBase.vue';
import DailyChallengeXPHeader from './components/DailyChallengeXPHeader.vue';
import DailyChallengeCard from './components/DailyChallengeCard.vue';

const XP_MODAL_DISMISSAL_KEY = '__DC_XP_MODAL_DISMISSED__';

enum XpModalState {
  Dismissed = 'dismissed',
}

@Component({
  components: { DailyChallengeBase, DailyChallengeCard, DailyChallengeXPHeader },
  computed: {
    ...mapState('dailyChallenges', ['dcs']),
    ...mapGetters('dailyChallenges', ['archivesCount']),
    ...mapState('globals', ['user']),
    ...mapGetters('globals', ['isAuthenticated']),
    ...mapGetters('leaguesMeta', ['enableLeagues']),
  },
  metaInfo(): MetaInfo {
    return {
      title: 'Daily Challenges',
      meta: [
        {
          name: 'description',
          content: 'Solve fun, daily challenges in math, science, and engineering.',
        },
      ],
    };
  },
})
export default class DailyProblemListings extends Vue {
  private user!: User;
  private xpModalIsDismissed: boolean = true;
  private readonly enableLeagues!: boolean;
  private readonly isAuthenticated!: boolean;

  dismissXpModal(): void {
    this.xpModalIsDismissed = true;

    if (typeof window !== 'undefined') {
      window.localStorage.setItem(XP_MODAL_DISMISSAL_KEY, XpModalState.Dismissed);
    }
  }

  private mounted(): void {
    this.xpModalIsDismissed = this.xpModalIsDismissedInStorage;
  }

  private get xpModalIsDismissedInStorage(): boolean {
    if (typeof window !== 'undefined') {
      return window.localStorage.getItem(XP_MODAL_DISMISSAL_KEY) === XpModalState.Dismissed;
    }

    return false;
  }

  private get xpModalIsVisible(): boolean {
    return this.enableLeagues && !this.xpModalIsDismissed && this.isAuthenticated;
  }
}
